import React from "react";
import { Pagination } from "@mui/material";
import { router } from "@inertiajs/react";

interface Meta {
    total: number;
    last_page: number;
    current_page: number;
    links: { url: string }[];
}

interface PaginationCompProps {
    meta: Meta;
    setLoading?: (loading: boolean) => void;
    isMapView?: boolean;
}

const PaginationComp: React.FC<PaginationCompProps> = ({
    meta,
    setLoading = null,
    isMapView,
}) => {

    const atLeastOne = meta.last_page[0] > 1;

    const handleChange = (event: React.ChangeEvent<unknown>, page: number) => {
        const selectedLink = new URL(meta.links[page].url);
        //set Map view only if there is a map (not on wishlists grid)
        if (isMapView !== undefined) {
            selectedLink.searchParams.set("isMapView", isMapView);
        }

        if (setLoading) setLoading(true);
        router.get(selectedLink);
    };

    return (
        <>
            {atLeastOne && (
                <Pagination
                    sx={{listStyle : 'none'}}
                    count={meta.last_page[0]}
                    page={meta.current_page[0]}
                    onChange={handleChange}
                />
            )}
        </>
    );
};

export default PaginationComp;
